import React, { useEffect, useState } from "react";
import styles from "./ValidateRegistrationPane.module.css";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../../axios/axios-apoteka";
import { getQueryParams, validateAppBrandId } from "../../../utils/urlUtils";

const ValidateRegistrationPane = (props) => {
  const [validationState, setValidationState] = useState({
    status: "loading", // 'loading' | 'success' | 'error'
    errorMessage: null,
  });

  useEffect(() => {
    const validateRegistration = async () => {
      try {
        // Extract appBrandId and type from URL query parameters
        const queryParams = getQueryParams(props.location.search);
        const appBrandId = validateAppBrandId(queryParams.appBrandId);
        const type = queryParams.type;

        const URL =
          baseUrl +
          "/authorization/validate_registration/" +
          props.match.params.email;

        // Include appBrandId and type in request params if present
        const requestParams = {
          access_token: props.match.params.token,
          ...(appBrandId && { appBrandId }),
          ...(type && { type }),
        };

        await axios.put(URL, null, {
          params: requestParams,
        });

        setValidationState({
          status: "success",
          errorMessage: null,
        });
      } catch (error) {
        console.error("Validation error:", error);
        setValidationState({
          status: "error",
          errorMessage: null,
        });
      }
    };

    validateRegistration();
  }, [
    props.match.params.email,
    props.match.params.token,
    props.location.search,
  ]);

  const renderContent = () => {
    switch (validationState.status) {
      case "loading":
        return (
          <div className={styles.loadingContainer}>
            <p>Verifikujemo Vaš nalog...</p>
          </div>
        );

      case "success":
        return (
          <div className={styles.successContainer}>
            <h2>Uspešno ste verifikovali nalog!</h2>
            <p>Molimo Vas da otvorite aplikaciju i prijavite se.</p>
          </div>
        );

      case "error":
        return (
          <div className={styles.errorContainer}>
            <p>
              {validationState.errorMessage ||
                "Nažalost, link za verifikaciju je istekao. Molimo Vas da pokušate ponovo da se registrujete i verifikujete Vaš nalog u roku od 60 minuta od prijema maila za potvrdu registracije."}
            </p>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className={styles.ValidateRegistrationPane}>{renderContent()}</div>
  );
};

export default withRouter(ValidateRegistrationPane);
